import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DriverList } from '@core/models/booking.model';
import { CompanyService, BreadcrumbItem } from '../../services/company.service';
import { ToastService } from '../../services/toast.service';
import { autoUnsubWith, Utility } from '../../services/utility.abstract';
import { DriverService } from '@core/services/driver.service';
import { Location } from '@angular/common';
import { DEFAULT_LOGO, END_DATE_GREATER, itemsPerPageList, SELECT_BOTH_DATES } from '../../constant/shared.constant';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonFunctions } from '@shared/common-functions';
import { CommonMenuService } from '@shared/services/common-util.service';
import { InvoiceType } from '../custom-invoice/custom-invoice.component';
import { InvoicePaymentStatus } from '@core/models/api-response.model';
import { ItemPerPage } from '@core/models/file-response.model';
import { PayRepayModalComponent } from '../pay-repay-modal/pay-repay-modal.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { SuperAdminService } from '@core/services/super-admin.service';

@Component({
  selector: 'app-driver-invoice-list',
  templateUrl: './driver-invoice-list.component.html',
  styleUrls: ['./driver-invoice-list.component.scss'],
})
export class DriverInvoiceListComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  invoiceList: any;
  itemsPerPage: number = 10;
  totalRecords: number;
  currentSkip: number = 0;
  currentPageUpcoming: number = 1;
  selectDriverStatus: any;
  CustomItemPerPageBy: ItemPerPage[] = itemsPerPageList;
  items: MenuItem[] | undefined;
  SearchItemPerPageBy: any;
  dummy = DEFAULT_LOGO;
  activeItem: any;
  excelFile: DriverList[] = [];
  invoiceListRequest: any;
  goToCurrentTab: boolean = false;
  showInput: boolean = false;
  role: string = '';
  roleRoute: string = '';
  searchStatus= null;
  selectStatus: { name: string; value: number }[] = [];
  chackFilterType: boolean = false;
  invoiceListForm: FormGroup;
  invoicePaymentStatus = InvoicePaymentStatus;

  constructor(
    private readonly driverService: DriverService,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly location: Location,
    private readonly fb: FormBuilder,
    private readonly dialogControlService: DialogControlService,
    private readonly commonMenuService: CommonMenuService,
    private readonly encryptStorage: EncryptionStorageService,
    private readonly superAdminService: SuperAdminService
  ) {
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
    this.invoiceListForm = this.fb.group({
      startDate: [''],
      endDate: [''],
      invoiceNumber: [''],
      paymentStatus:[null]
    });
  }

  ngOnInit() {
    this.superAdminService.popupClosed$.subscribe((refresh) => {
      if (refresh) {
        this.getParkingLotInvoiceForDriver('firsttime');
      }
    });
    this.selectStatus = [
      { name: 'All', value: null  },
      { name: 'Paid', value: 1 },
      { name: 'Pending', value: 0 },
      { name: 'In-Process', value: 3 },
      {name: 'Cancelled', value: 4 },
      { name: 'Payment Failed', value: 2 },
    ];
    this.getParkingLotInvoiceForDriver('firsttime');
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'My Invoices',
      },
    ];

    this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.goToTop();
  }

    getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }

  checkDataTimeValidation() {
    const startDateControl = this.invoiceListForm.get('startDate');
    const endDateControl = this.invoiceListForm.get('endDate');
  
    if (startDateControl.value) {
      const startDate = new Date(startDateControl.value);
      startDate.setHours(0, 0, 0, 0);
    }
  
    if (endDateControl.value) {
      const endDate = new Date(endDateControl.value);
      endDate.setHours(23, 59, 59, 999);
    }
  
    if (!startDateControl.value && !endDateControl.value) {
      return true;
    } else if (startDateControl.value && !endDateControl.value) {
      this.toastService.showToastMessage('error', 'Error', SELECT_BOTH_DATES);
      return false;
    } else if (!startDateControl.value && endDateControl.value) {
      this.toastService.showToastMessage('error', 'Error', SELECT_BOTH_DATES);
      return false;
    } else if (new Date(endDateControl.value) < new Date(startDateControl.value)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        END_DATE_GREATER
      );
      return false;
    }
    return true;
  }

  searchByFilter() {
    if (this.checkDataTimeValidation()) {
      this.getParkingLotInvoiceForDriver('search');
    }
  }

  getParkingLotInvoiceForDriver(changeAction) {
    
    if (changeAction === 'reset') {
      this.invoiceListRequest = {
        name: '',
        phoneNumber: '',
        startDate: '',
        endDate: '',
        parkingLotName: '',
        invoiceNumber: '',
        paymentStatus : this.searchStatus,
        pageNumber: 1,
        pageSize: this.itemsPerPage,
        timeZone: Utility.getLocalTimeZone(),
      };
    } else if (changeAction === 'search') {
      this.invoiceListRequest = {
        name: '',
        phoneNumber: '',
        paymentStatus : this.searchStatus,
        startDate:
            this.invoiceListForm.get('startDate').value,
        endDate:
            this.invoiceListForm.get('endDate').value,
        parkingLotName: '',
        invoiceNumber: this.invoiceListForm.value.invoiceNumber,
        pageNumber: 1,
        pageSize: this.itemsPerPage,
        timeZone: Utility.getLocalTimeZone(),
      };
    } else {
      if (changeAction === 'pagechange') {
        this.invoiceListRequest = {
          name: '',
          phoneNumber: '',
          paymentStatus : this.searchStatus,
          startDate:
            this.invoiceListForm.get('startDate').value,
          endDate:
              this.invoiceListForm.get('endDate').value,
          parkingLotName: '',
          invoiceNumber: this.invoiceListForm.value.invoiceNumber,
          pageNumber: this.currentPageUpcoming,
          pageSize: this.itemsPerPage,
          timeZone: Utility.getLocalTimeZone(),
        };
      } else {
        this.invoiceListRequest = {
          name: '',
          phoneNumber: '',
          startDate: '',
          endDate: '',
          parkingLotName: '',
          paymentStatus : this.searchStatus,
          invoiceNumber: this.invoiceListForm.value.invoiceNumber,
          pageNumber: this.currentPageUpcoming,
          pageSize: this.itemsPerPage,
          timeZone: Utility.getLocalTimeZone(),
        };
      }
    }
    this.driverService
      .getParkingLotInvoiceForDriver(this.invoiceListRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (changeAction === 'search') {
            this.currentSkip = 0;
            CommonFunctions.scrollTopRow('top');
          }
          this.totalRecords = response.totalRecords;
          this.invoiceList = response.data;
          this.excelFile = this.invoiceList;
          
        },
        error: (_error) => {
          this.currentSkip = 0;
          this.invoiceList = [];
        },
      });
  }

  onPageChange(event: any) {
    this.currentSkip = event.first;
    this.currentPageUpcoming = event.page + 1;
    CommonFunctions.scrollTopRow('top');
    this.getParkingLotInvoiceForDriver('pagechange');
  }

  onDropdownChange(event: any) {
    this.itemsPerPage = event.value;
    this.currentSkip = 1;
    this.currentPageUpcoming = 1;
    CommonFunctions.scrollTopRow('top');
    this.getParkingLotInvoiceForDriver('dropdownchange');
  }

  getFlagClass(iso: string): string {
    const lowerCaseIso = iso?.toLowerCase();
    return `fi fi-${lowerCaseIso}`;
  }

  resetFilter() {
    this.currentPageUpcoming = 1;
    this.itemsPerPage = 10;
    this.currentSkip = 0;
    this.SearchItemPerPageBy = null;
    this.searchStatus = null;
    this.getParkingLotInvoiceForDriver('reset');
    this.invoiceListForm.reset();
    this.goToTop();
  }

  goToTop() {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  showData(rowData: any) {
    const actionMap = {
      viewInvoice: () => {
        this.downloadInvoice(rowData.id);
      },
      pay: () => {
        this.dialogControlService.openDialog(PayRepayModalComponent, {
          styleClass: 'pay-repay',
          data: {
            id: null,
            invoiceId: rowData.id,
            driverId: rowData.driverId,
            bookingType: false,
          },
        });
      },
    };
    const config = [
      {
        label: '',
        icon: '',
        escape: false,
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        escape: false,
        command: actionMap.viewInvoice,
      },
      {
        label:  rowData.status ==='Payment Failed'? 'Re-Pay': 'Pay',
        icon: 'common-icon custom-pay',
        visible: rowData.status === 'Pending' ||  rowData.status ==='Payment Failed',
        command: actionMap.pay
      },
    ];
    this.items = this.commonMenuService.commonShowData(config);
  }

  downloadInvoice(id) {
    const req = { 
      InvoiceType : InvoiceType.OneTimeInvoice,
      id: id };;

    this.driverService
      .downloadInvoice(req)
      .pipe( autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (_response) => {
          const url = _response.data as string;
          window.open(url, '_blank');
        },
        error: (er: Error) => {
          this.toastService.showToastMessage('error', 'Error', er.message);
        },
      });
  }

  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
  onChangePaymentStatus(event: any) {
    this.searchStatus = event.value;
  }

  backRoute() {
    this.location.back();
  }

}
